//eSefaz
export const NOME_SISTEMA = "PF";

//DebtStates
export const VINCENDO = 'Vincendo';
export const VENCIDO = 'Vencido';
export const EXIGIBILIDADE_SUSPENSA = 'Exigibilidade suspensa'; 

//FilterDebitsManager
export const SOMENTE_VINCENDO = 'Somente Vincendo';
export const SOMENTE_VENCIDO = 'Somente Vencido';
export const SOMENTE_EXIGIBILIDADE_SUSPENSA = 'Somente Exigibilidade Suspensa';

//Bancos
export const LABEL_PERMITE_PGTO_DAM = 'Permite pagamento por DAM';
export const LABEL_PERMITE_PGTO_ONLINE = 'Permite pagamento online';
export const LABEL_PERMITE_DEBITO_AUT = 'Permite débito automático';
export const LABEL_PERMITE_CAD_MISTO = 'Permite cadastramento misto';
export const LABEL_EXIGE_CONFIRMACAO = 'Exige confirmação do banco';

//Perfis eSefaz
export const PERFIL_GESTOR = 'GESTOR';
export const PERFIL_ADMINISTRADOR = 'ADMINISTRADOR';
export const PERFIL_CONTRIBUINTE = 'CONTRIBUINTE';
export const PERFIL_ATENDENTE = 'ATENDENTE';

// Situação do débito 
export const DEBITO_QUITADO = 'Q'

//Preferências
export const PREFERENCIAS_ORGANIZACAO = {
  date: 'DTVENCIMENTO',
  debit: 'TIPODEBITO',
  value: 'VALOR'
}

export const PREFERENCIAS_APRESENTACAO = {
  card: 'CARD',
  list: 'LISTA',
}

export const PREFERENCIAS_EXIBICAO = {
  todos: 'TODOS',
  pagos: 'PAGOS',
  vencido: 'VENCIDOS',
  vincendo: 'VINCENDOS'
}

// Filtros de Débito (Visão Contribuinte)
export const filtrosOrganizacao = {
  DATA_VENCIMENTO: 'date',
  TIPO_DEBITO: 'debit',
  VALOR: 'value'
}

export const filtrosTipoApresentacao = {
  CARD: 'card',
  LIST: 'list',
}

export const filtrosExibicao = {
  TODOS: 'todos',
  PAGOS: 'pagos',
  VENCIDOS: 'vencido',
  VINCENDOS: 'vincendo'
}

export default {
    NOME_SISTEMA,
    SOMENTE_VINCENDO,
    SOMENTE_VENCIDO,
    SOMENTE_EXIGIBILIDADE_SUSPENSA,
    PERFIL_GESTOR,
    PERFIL_ADMINISTRADOR,
    PERFIL_CONTRIBUINTE,
    PERFIL_ATENDENTE,
    LABEL_PERMITE_PGTO_DAM, 
    LABEL_PERMITE_PGTO_ONLINE,
    LABEL_PERMITE_DEBITO_AUT,
    LABEL_PERMITE_CAD_MISTO, 
    LABEL_EXIGE_CONFIRMACAO, 
  };
  